import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import classNames from 'classnames';
import _ from 'lodash';
import Moment from 'moment';
import Dropzone from 'react-dropzone';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Link, withRouter } from 'react-router';
import { Field, FieldArray } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, Tabs, Tab, Textarea, Image } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import { Selection, SelectionWide } from '../Common/selection';
import { DetailedSelection, VirtualizedDetailedSelection } from '../Common/detailedSelection';
import { InputField, DisabledInputField, ControlledInputField} from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import ConvertItemPrice from '../Common/convertItemPrice';
import HiddenInputField from '../Common/hiddenInputField';
import PriceField from '../Common/priceField';
import Spinner from '../Widgets/spinner';
import ProductArray from './productArray';
import VendorForm from '../../containers/Products/vendorForm';
import { Translate, Localize } from 'react-redux-i18n';

momentLocalizer(Moment);

const renderInvoice = ({ fields }) => (
    <Row><Col sm={ 12 }>
        <Row><Col sm={ 12 }>
            <Button type="button" className="btn btn-green btn-green-default" onClick={() => {
                fields.push({})   // pushes empty child field onto the end of the array
            } }><i/> <Translate value="add_invoice" />
            </Button>
        </Col></Row>
        <Row><Col sm={ 12 }>
            {!fields.length && <div className="marginTopStyle" ><Translate value="no_invoice" /></div>}
            {fields.map((Invoice, index) =>
                <div key={ index }>
                    <Row className="marginTopStyle marginBottomStyle" >
                        <label className="col-sm-5"><Translate value="invoice_no" />{index + 1}</label>
                        <Button className="col-sm-3 btn btn-warning" type="button" onClick={() => {
                            fields.remove(index)  // remove from index
                        } }><i/> <Translate value="remove" />
                        </Button>
                    </Row>
                    <Row className="marginBottomStyle" >
                        <label className="col-sm-3 marginTopStyle" ><Translate value="vendor_invoice_no" />: </label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.VendorInvoiceNum`} component={ InputField }/>
                        </Col>
                    </Row>
                    <Row className="marginBottomStyle" >
                        <label className="col-sm-3 marginTopStyle" ><Translate value="invoice_total" />: </label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.InvoiceTotal`} component={ PriceField }/>
                        </Col>
                    </Row>
                    <Row className="marginBottomStyle">
                        <label className="col-sm-3 marginTopStyle" ><Translate value="invoice_date" />: </label>
                        <Col sm={ 8 }>
                            <Field name={`${Invoice}.InvoiceDate`} component={ DatePicker }/>
                        </Col>
                    </Row>
                </div>
            ) }
        </Col></Row>
    </Col></Row>
)

class PurchaseQuoteForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            files: null,

            leftBarHeight: window.innerHeight - UI_HEIGHT.leftBar,
            rightBarHeight: window.innerHeight - UI_HEIGHT.rightBar,

            productInfo: null,
            totalNetWeight: 0,
            totalShippingWeight: 0,
            totalPrice: 0,

            taxValue: 0,
            discountValue: 0,

            defaultRefPrice: 0,
            refPrice: 0,
            defaultLowestSalePrice: 0,
            lowestSalePrice: 0,
            quantity: 0,

            firstRender: false,

            priceType: 'FOB',
            finalPrice: 0,
            miscCostValue: 0,
            handlingCostValue: 0,
            shippingCostValue: 0,

            calculatedProducts: [],

            vendorInformationOpen: true,
            oneTimeScheduleOpen: true,
            purchaseInformationOpen: true,
            orderHistoryOpen: true,
            inventoryOpen: true,

            dirty: false,

            rows: [],
            selectedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null
        }
        this.placeNewOrder = this.placeNewOrder.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleMiscCostChange = this.handleMiscCostChange.bind(this);
        this.handleShippingCostChange = this.handleShippingCostChange.bind(this);
        this.handleHandlingCostChange = this.handleHandlingCostChange.bind(this);
        this.handleDiscountChange = this.handleDiscountChange.bind(this);
        this.handleTaxChange = this.handleTaxChange.bind(this);
        this.handleUnitPriceChange = this.handleUnitPriceChange.bind(this);
        this.handleLowestSalePriceChange = this.handleLowestSalePriceChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
    }

    componentWillMount() {
      this.props.fetchSimplifiedProducts();
    }

    componentDidMount() {
        const { currentPurchaseQuote, currentPurchaseQuoteDetail, currentPurchaseTemplate, currentPurchaseTemplateDetail } = this.props;

        // If user is editing Purchase Quote, load the detail information of
        // selected purchase quote.
        if (currentPurchaseQuote) {
            this.props.fetchPurchaseQuoteDetail
                (currentPurchaseQuote.PurchaseOrder_id)
                .then(() => {
                    this.props.fetchVendors();
                    this.props.fetchPaymentTerms();
                    this.props.fetchWarehouses();
                });
        }
        else if (currentPurchaseTemplate) {
            this.props.convertTemplateToQuote(currentPurchaseTemplate.PurchaseTemplate_id)
                .then(() => {
                    this.props.fetchVendors();
                    this.props.fetchPaymentTerms();
                    this.props.fetchWarehouses();
                });
        }
        else {
            this.props.fetchVendors();
            this.props.fetchPaymentTerms();
            this.props.fetchWarehouses();
        }

        window.addEventListener('resize', this.handleResize);
        // making a leaving hook to confirm leaving
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.productInformation && nextProps.productInformation != this.props.productInformation) {
          const products = this.props.products;
          const productInformation = nextProps.productInformation;
          const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
          if(products[index])
            this.props.fetchProductInfo(products[index].Product_id);
        }
        if(nextProps.productInfo && nextProps.productInfo != this.props.productInfo) {
          this.setState({productInfo: nextProps.productInfo});
        }
        if(nextProps.miscCostValue && nextProps.miscCostValue != this.props.miscCostValue) {
          this.setState({miscCostValue: nextProps.miscCostValue})
        }
        if(nextProps.handlingCostValue && nextProps.handlingCostValue != this.props.handlingCostValue) {
          this.setState({handlingCostValue: nextProps.handlingCostValue})
        }
        if(nextProps.shippingCostValue && nextProps.shippingCostValue != this.props.shippingCostValue) {
          this.setState({shippingCostValue: nextProps.shippingCostValue})
        }
        if (nextProps.dirty != this.props.dirty) {
            this.setState({
                dirty: nextProps.dirty
            });
        }

        // Once user select a vendor, load its address and contacts.
        if (nextProps.vendorsValue != this.props.vendorsValue) {
            // When first render the page, vendorsValue doesn't exist.
            if (this.refs.Products && this.props.vendorsValue && !this.state.firstRender) {
                this.refs.Products.getRenderedComponent().props.fields.removeAll();
            }
            if (nextProps.vendorsValue != null) {
                this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
                this.props.fetchProductsByVendor(nextProps.vendorsValue.value || nextProps.vendorsValue);
            }
            if (this.state.firstRender) this.state.firstRender = false
        }

        // Also, if vendor has been chosen in the quote or template user'll work on, load related products.
        if (nextProps.currentPurchaseQuoteDetail != this.props.currentPurchaseQuoteDetail && nextProps.currentPurchaseQuoteDetail) {
          const  currentPurchaseQuoteDetail = nextProps.currentPurchaseQuoteDetail;
          if(currentPurchaseQuoteDetail.Purchase_Order_Line != null){
            let newRows = [];
            currentPurchaseQuoteDetail.Purchase_Order_Line.map(
              (line) => {
                let newProduct = {};
                newProduct["Product_id"] = line.Product_id.Product_id;
                newProduct["Name"] = line.Product_id.Name;
                newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
                newProduct["Quantity"] = line.Quantity;
                newProduct["EstSaleTotal"] = line.EstSaleTotal;


                newProduct["ProductNum"] = line.Product_id.ProductNum;
                newProduct["Description"] = line.Product_id.Description;
                newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
                newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
                newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
                newProduct["NetWeight"] = line.Product_id.NetWeight;
                newProduct["TotalNetWeight"] = (line.Product_id.NetWeight)*(line.Quantity);
                newProduct["TotalShippingWeight"] = (line.Product_id.ShippingWeight)*(line.Quantity);
                newProduct["RefNum"] = line.Product_id.RefNum;
                newProduct["TotalPrice"] = line.TotalPrice;

                newRows = [...newRows, newProduct];
              }
            )
            let newTotalShippingWeight = currentPurchaseQuoteDetail.FinalShippingWeight;
            let newTotalNetWeight = currentPurchaseQuoteDetail.FinalNetWeight;
            let newTotalPrice = currentPurchaseQuoteDetail.TotalPrice;
            let finalPrice = currentPurchaseQuoteDetail.FinalPrice;
            let taxValue = currentPurchaseQuoteDetail.TaxRate;
            let discountValue = currentPurchaseQuoteDetail.Discount;

            this.setState({ rows: newRows,
              totalShippingWeight: newTotalShippingWeight,
              totalNetWeight: newTotalNetWeight,
              totalPrice: newTotalPrice,
              finalPrice: finalPrice,
              taxValue: taxValue,
              discountValue: discountValue
            });
          }
            this.setState({ firstRender: true })
        }

        if (!nextProps.vendorsValue) {
            this.props.resetCurrentVendor();
        }

        if (nextProps.priceTypeValue != this.props.priceTypeValue) {
            this.setState({ priceType: nextProps.priceTypeValue });
        }

        // Calculate the sum of the price and weight for products.

        if (nextProps.products[0] && nextProps.productsValue) {

            let { products, productInformation, quantity, shippingCostValue, handlingCostValue, miscCostValue, discountValue, taxValue } = nextProps;

            let createPurchaseQuote = 0;
            let totalShippingWeight = 0;

            let calculatedProducts = nextProps.productsValue;

            function round(value, decimals) {
                return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
            }

            // calculatedProducts.map(
            //     product => {
            //         if (product.Product_id) {
            //             const index = _.findIndex(products, { 'Product_id': product.Product_id.value || product.Product_id });
            //             if (index > -1) {
            //                 product['Title'] = products[index].Name + ' No. ' + products[index].ProductNum;
            //                 product['TotalNetWeight'] = ((parseFloat(products[index].NetWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
            //                 product['TotalShippingWeight'] = ((parseFloat(products[index].ShippingWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
            //                 product['TotalPrice'] = ((parseFloat(product.FOBUnitPrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
            //                 product['EstSaleTotal'] = ((parseFloat(product.EstSalePrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
            //                 // Generate the unit of measure field
            //                 product['UnitOfMeasure'] = products[index].PackageSize + '/' + products[index].PackageType;
            //             }
            //         } else {
            //             product['Title'] = "Please Choose a Product";
            //             product['TotalNetWeight'] = 0;
            //             product['TotalShippingWeight'] = 0;
            //             product['TotalPrice'] = 0;
            //             product['EstSaleTotal'] = 0;
            //         }
            //         createPurchaseQuote = (parseFloat(totalPrice) + (parseFloat(product.TotalPrice) || 0)).toFixed(2);
            //         totalShippingWeight = (parseFloat(totalShippingWeight || 0) + parseFloat(product.TotalShippingWeight || 0)).toFixed(2);
            //         totalNetWeight = (parseFloat(totalNetWeight || 0) + parseFloat(product.TotalNetWeight || 0)).toFixed(2);
            //         // Calculating the Final Price
            //         finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
            //     }
            // )

            this.setState({
                calculatedProducts: calculatedProducts,
                // totalPrice: totalPrice,
                // totalShippingWeight: totalShippingWeight,
                // totalNetWeight: totalNetWeight
            })
        }

        if (nextProps.allProducts && nextProps.allProducts != this.props.allProducts) {
          console.log("next product", nextProps.allProducts);
          let index = _.findIndex(this.props.simplifiedProducts, {'Product_id': nextProps.allProducts.value });
          console.log(index);
          if (index > -1) {
            this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseQuoteForm');
          }
        }

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize(e) {
        this.setState({
            leftBarHeight: window.innerHeight - UI_HEIGHT.leftBar,
            rightBarHeight: window.innerHeight - UI_HEIGHT.rightBar
        });
    }

    // If the form is dirty, ask for confirmation.

    routerWillLeave(nextLocation) {
        if (this.state.dirty) return <Translate value="work_not_saved_warning" />
    }

    title() {
        if (!this.props.params.id) {
            return <div className="content-heading"><Translate value="create_a_new_purchase_quote" /></div>
        }
        return <div className="content-heading"><Translate value="edit_purchase_quote" /> {this.props.currentPurchaseQuote.PONum}</div>
    }

    placeButtons() {
      const { submitting, pristine, isCreating, isEditing } = this.props;
      if(!this.props.params.id){
        return (
          <Button className="btn btn-primary pull-right" disabled={ isCreating || isEditing || pristine } type="submit" ><em className="fa fa-save marginRightStyle" /><Translate value="save" /></Button>
        )
      }
      return (
        <Row>
          <Button className="btn btn-primary pull-right" disabled={ isCreating || isEditing || pristine } type="submit" ><em className="fa fa-save marginRightStyle" /><Translate value="save" /></Button>
          <Button className="btn btn-primary pull-right" disabled={ isCreating || isEditing } onClick={e => this.placeNewOrder(e) } ><em className="fa fa-save marginRightStyle" /><Translate value="place_new_order" /></Button>
        </Row>
      )
    }
    // Render Select options dynamically with the information on the server.

    renderVendors() {
        if (this.props.vendorIsLoading) return <Spinner/> // If vendor is loading, show a spinner.
        else {
            let vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
            let vendorNumOptions = this.getVendorNumOptions();
            return (
                <Row className="marginBottomStyle">
                    <Col sm={ 12 }>
                        <Row><Col sm={9}>
                            <label><Translate value="vendor_no" /></label>
                        </Col></Row>
                        <Row>
                            <Col sm={ 8 }>
                                <Field name="Vendor_id" component={Selection} options={vendorNumOptions}/>
                            </Col>
                        </Row>
                    </Col>
                    <br/>
                </Row>
            )
        }
    }


    renderVendorsDetail() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/> // If vendor is loading, show a spinner.
        else if (this.props.vendorError) return <div><Translate value="error" /></div> // If vendor is loading, show a spinner.
        else {
            let vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
            let vendorNumOptions = this.getVendorNumOptions();
            return (
                <div>
                  <Row className="marginBottomStyle">
                        <Col sm={ 6 }>
                          <label className="col-sm-6 inlineLabel" ><Translate value="vendor_name" /> <span style={{color: 'red'}} >*</span> </label>
                          <Col sm={ 6 }>
                            <Field name="Vendor_id" component={Selection} options={vendorNameOptions}/>
                          </Col>
                        </Col>
                        <Col sm={ 6 }>
                          <label className="col-sm-6 inlineLabel" ><Translate value="vendor_no" /> <span style={{color: 'red'}} >*</span> </label>
                          <Col sm={ 6 }>
                            <Field name="Vendor_id" component={Selection} options={vendorNumOptions}/>
                          </Col>
                        </Col>
                        <br/>
                    </Row>
                </div>
            )
        }
    }

    // Push vendor name and number in to 2 JSON arrays.

    getVendorNameOptions() {
        var vendorNameOptions = [];
        this.props.vendors.map(vendor => {
            vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
        });
        return vendorNameOptions;
    }

    getVendorNumOptions() {
        let vendorNumOptions = [];
        this.props.vendors.map(vendor => {
            vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
        });
        return vendorNumOptions;
    }

    renderBillingAddress() {
        const { vendorsValue, currentVendorDetail } = this.props;
        if (currentVendorDetail) {
            const BillingAddress = currentVendorDetail.BillingAddress.Name + ', ' +
                currentVendorDetail.BillingAddress.Street + ', ' +
                currentVendorDetail.BillingAddress.City;
            return BillingAddress;
        }
    }

    // Once a vendor is chosen, render its shipping address and contacts

    renderVendorAddress() {
        if (this.props.vendorDetailIsLoading && !this.props.vendorDetailError) return <Spinner/> // If vendor is loading, show a spinner.
        else if (this.props.vendorDetailError) return <div><Translate value="error" /></div> // If vendor is loading, show a spinner.
        else if (this.props.currentVendorDetail) {
            let vendorAddressOptions = this.getVendorAddressOptions();
            let vendorContactOptions = this.getVendorContactOptions();
            return (
                <Row>
                  <Col sm={6}>
                    <label className="col-sm-5 inlineLabel" ><Translate value="pickup_vendor_address" /></label>
                    <Col sm={ 6 }>
                      <Field name="Pickup_VendorAddress_id" component={Selection} options={vendorAddressOptions} />
                    </Col>
                  </Col>
                  <Col sm={6}>
                    <label className="col-sm-5 inlineLabel" ><Translate value="pickup_contact" /></label>
                      <Col sm={ 6 }>
                        <Field name="Pickup_VendorContact_id" component={Selection} options={vendorContactOptions} />
                    </Col>
                    <br/>
                    {this.renderVendorContactInformation() }
                  </Col>
                </Row>
            )
        }
        else return <h4 className='centerStyle' ><Translate value="msg_please_select_a_vendor" /></h4>
    }

    getVendorAddressOptions() {
        var vendorAddressOptions = [];
        this.props.currentVendorDetail.ShippingAddress.map(address => {
            vendorAddressOptions.push({ value: address.VendorAddress_id, label: address.Name + ', ' + address.City })
        });
        return vendorAddressOptions;
    }

    getVendorContactOptions() {
        var vendorContactOptions = [];
        this.props.currentVendorDetail.ShippingContact.map(contact => {
            // Including phone and email in the option
            vendorContactOptions.push({ value: contact.VendorContact_id, label: contact.FirstName + ' ' + contact.LastName + ' Phone: ' + contact.Cellphone + ' Email: ' + contact.Email })
        });
        return vendorContactOptions;
    }

    renderVendorContactInformation() {
        const { currentVendorDetail, vendorsValue, vendorContactValue } = this.props;
        if (vendorContactValue && currentVendorDetail) {
            const index = _.findIndex(currentVendorDetail.ShippingContact, { 'VendorContact_id': vendorContactValue });
            if (index != -1) return (
                <div>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="name" />: </label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].FirstName + ' ' + currentVendorDetail.ShippingContact[index].LastName}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="email" />: </label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].Email}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={ 3 }>
                            <label><Translate value="phone" />: </label>
                        </Col>
                        <Col sm={ 9 }>
                            {currentVendorDetail.ShippingContact[index].Telephone}
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    // Render the Array of products.

    // renderProducts() {
    //     if (!this.props.vendorsValue &&
    //         (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.Vendor_id)))
    //         return <h4>Please Select a Vendor</h4>
    //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
    //     else {
    //         const { miscCostValue, handlingCostValue, shippingCostValue } = this.props;
    //         let productNumOptions = this.getProductNumOptions();
    //         let productNameOptions = this.getProductNameOptions();
    //         let totalCost = (parseFloat(shippingCostValue || 0) + parseFloat(miscCostValue || 0) + parseFloat(handlingCostValue || 0)).toFixed(2)
    //         return (
    //             <FieldArray name="Purchase_Order_Line"
    //                 ref="Products"
    //                 component={ProductArray}
    //                 productNameOptions={productNameOptions}
    //                 productNumOptions={productNumOptions}
    //                 calculatedProducts={this.state.calculatedProducts}
    //                 productsValue={this.props.productsValue}
    //                 products={this.props.products}
    //                 priceType={this.state.priceType }
    //                 totalPrice={this.state.totalPrice}
    //                 totalCost={totalCost}
    //                 withRef />
    //         )
    //     }
    // }

    moveToProductsList(){
      const { products, productInformation } = this.props;
      const quantity = this.state.quantity;
      let newProduct = {};
      const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
      let refPrice = this.state.refPrice || this.state.defaultRefPrice || products[index].FOBUnitPrice || 0;
      let lowestSalePrice = this.state.lowestSalePrice || this.state.defaultLowestSalePrice || products[index].LowestSalePrice || 0;
      newProduct["Product_id"] = products[index].Product_id;
      newProduct["ProductNum"] = products[index].ProductNum;
      newProduct["Name"] = products[index].Name;
      newProduct["Description"] = products[index].Description;
      newProduct["MeasureUnit"] = products[index].MeasureUnit;
      newProduct["EstSalePrice"] = lowestSalePrice; //products[index].LowestSalePrice;
      newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
      newProduct["ShippingWeight"] = products[index].ShippingWeight;
      newProduct["NetWeight"] = products[index].NetWeight;
      newProduct["TotalShippingWeight"] = (products[index].ShippingWeight)*(quantity);
      newProduct["TotalNetWeight"] = (products[index].NetWeight)*(quantity);
      newProduct["RefNum"] = products[index].RefNum;
      newProduct["Quantity"] = quantity;
      newProduct["TotalPrice"] = parseFloat(quantity*refPrice).toFixed(2);
      newProduct["EstSaleTotal"] = parseFloat(quantity*lowestSalePrice).toFixed(2);
      const newRows = [...this.state.rows, newProduct];
      let totalShippingWeight = parseFloat(this.state.totalShippingWeight) + quantity*parseFloat(newProduct["ShippingWeight"]);
      totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
      let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
      totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
      let totalPrice = parseFloat(this.state.totalPrice) + quantity*parseFloat(newProduct["FOBUnitPrice"]);
      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      let discountValue = this.state.discountValue;
      let taxValue = this.state.taxValue;
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState(...this.state, {rows: newRows,
        totalShippingWeight: totalShippingWeight,
        totalNetWeight: totalNetWeight,
        totalPrice: totalPrice,
        finalPrice: finalPrice,
        defaultRefPrice: 0,
        refPrice: 0,
        defaultLowestSalePrice: 0,
        lowestSalePrice: 0,
        quantity: 0
      });
    }

    moveOffFromProductsList(){
        let newRows = this.state.rows;
        let totalShippingWeight = 0;
        let totalNetWeight = 0;
        let totalPrice = 0;
        let discountValue = this.state.discountValue;
        let taxValue = this.state.taxValue;
        newRows = newRows.filter(function(obj){
              return obj.isSelected == false || obj.isSelected == null;
            })

        newRows.map(
          newRow => {
            totalShippingWeight = parseFloat(totalShippingWeight) + parseFloat(newRow["Quantity"])*parseFloat(newRow["ShippingWeight"]);
            totalNetWeight = parseFloat(totalNetWeight) + parseFloat(newRow["Quantity"])*parseFloat(newRow["NetWeight"]);
            totalPrice = parseFloat(totalPrice) + parseFloat(newRow["TotalPrice"]);
          }
        )
        totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
        totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
        totalPrice = (parseFloat(Math.round(totalPrice * 100) / 100) + parseFloat(this.state.miscCostValue) + parseFloat(this.state.handlingCostValue) + parseFloat(this.state.shippingCostValue)).toFixed(2);
        let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
        this.setState({rows: newRows, selectedRows: [], totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    setDefault() {
      const { productInformation } = this.props;
      if(productInformation){
        const products = this.props.products;
        const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
        if(products[index] != null){
          if(this.state.defaultRefPrice != products[index].RefPrice)
            this.setState({defaultRefPrice: products[index].RefPrice});
          if(this.state.defaultLowestSalePrice != products[index].LowestSalePrice)
            this.setState({defaultLowestSalePrice: products[index].LowestSalePrice});
        }
      }
    }

    handleUnitPriceChange(event) {
        this.setState({refPrice: event.target.value});
    }

    handleLowestSalePriceChange(event) {
      this.setState({lowestSalePrice: event.target.value});
    }

    handleQuantityChange(event) {
      this.setState({quantity: event.target.value});
    }

    renderProducts() {
      if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
        let productNumOptions = this.getProductNumOptions();
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the row select function

        const onRowSelect = rows => {
            this.setState(...this.state, { selectedRows: rows });
        }

        const onRowsSelected = (rows) => {
             let newRows = this.state.rows;
             rows.map (r => {
               newRows[r.rowIdx].isSelected = true;
             });
             this.setState({rows: newRows});
        }

         const onRowsDeselected = (rows) => {
             let newRows = this.state.rows;
             rows.map (r => {
               newRows[r.rowIdx].isSelected = false;
             });
             this.setState({rows: newRows});
         }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        const onRowClick = (rowIdx, row) => {
            this.props.fetchSalesOrders();
        }

        // Handle the editable function

        const handleRowUpdated = e => {

          var rows = getRows();
          let totalShippingWeight = this.state.totalShippingWeight;
          let totalNetWeight = this.state.totalNetWeight;
          let totalPrice = this.state.totalPrice;
          let discountValue = this.state.discountValue;
          let taxValue = this.state.taxValue;
          if(e.updated.Quantity != null){
            let quantity = rows[e.rowIdx].Quantity;
            Object.assign(rows[e.rowIdx], e.updated);
            Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.Quantity*rows[e.rowIdx].FOBUnitPrice).toFixed(2)});
            Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.Quantity*rows[e.rowIdx].EstSalePrice).toFixed(2)});
            totalShippingWeight = parseFloat(this.state.totalShippingWeight) + (e.updated.Quantity-quantity)*parseFloat(rows[e.rowIdx].ShippingWeight);
            totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
            totalNetWeight = parseFloat(this.state.totalNetWeight) + (e.updated.Quantity-quantity)*parseFloat(rows[e.rowIdx].NetWeight);
            totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
            totalPrice = parseFloat(this.state.totalPrice) + (e.updated.Quantity-quantity)*parseFloat(rows[e.rowIdx].FOBUnitPrice);
            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
          }
          else if(e.updated.FOBUnitPrice != null){
            let FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
            Object.assign(rows[e.rowIdx], e.updated);
            Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.FOBUnitPrice*rows[e.rowIdx].Quantity).toFixed(2)});
            totalPrice = parseFloat(this.state.totalPrice) + rows[e.rowIdx].Quantity*(parseFloat(e.updated.FOBUnitPrice)-parseFloat(FOBUnitPrice));
            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
          }
          else if(e.updated.EstSalePrice != null){
            let quantity = rows[e.rowIdx].Quantity;
            let lowestSalePrice = rows[e.rowIdx].EstSalePrice;
            Object.assign(rows[e.rowIdx], e.updated);
            Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.EstSalePrice*rows[e.rowIdx].Quantity).toFixed(2)});
          }

          let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
          this.setState({rows:rows, totalShippingWeight: totalShippingWeight, totalNetWeight: totalNetWeight, totalPrice: totalPrice, finalPrice: finalPrice});

            // // merge updated row with current row and rerender by setting state
            // let rows = this.state.rows.slice(0);
            // let editedRows = this.state.editedRows.slice(0);
            // Object.assign(rows[e.rowIdx], e.updated);
            // // if the element is already edited, remove the old one.
            //
            // editedRows.forEach((element, index) => {
            //     if (element.ProductNum === rows[e.rowIdx].ProductNum)
            //         editedRows.splice(index, 1)
            // }, this);
            // // push the row into the editedRows array
            // editedRows.push(rows[e.rowIdx]);
            // this.setState({
            //     rows: rows,
            //     editedRows: editedRows
            // });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNameFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.Name}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNumFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        // Column difinition

        const columns = [
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 80,
              filterable: true
          },
          {
              key: 'Name',
              name: <Translate value="name" />,
              resizable: true,
              sortable: true,
              width: 100,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              resizable: true,
              sortable: true,
              width: 200,
              filterable: true,
          },
          {
              key: 'MeasureUnit',
              name: <Translate value="measure_unit" />,
              resizable: true,
              sortable: true,
              width: 80,
              filterable: true
          },
          {
              key: 'ShippingWeight',
              name: <Translate value="weight" />,
              resizable: true,
              sortable: true,
              width: 80,
              filterable: true,
          },
          {
              key: 'Quantity',
              name: <Translate value="quantity" />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 80,
              filterable: true,
          },
          {
              key: 'FOBUnitPrice',
              name: <Translate value="unit_price" />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 100,
              filterable: true
          },
          {
              key: 'TotalPrice',
              name: <Translate value="total_price" />,
              resizable: true,
              sortable: true,
              width: 100,
              filterable: true,
          },
          {
              key: 'EstSalePrice',
              name: <Translate value="lowest_sale_dollarsign" />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 100,
              filterable: true
          },
          {
              key: 'EstSaleTotal',
              name: <Translate value="et_sale_total" />,
              resizable: true,
              sortable: true,
              width: 100,
              filterable: true,
          },
          {
              key: 'RefNum',
              name: <Translate value="ref_num" />,
              resizable: true,
              sortable: true,
              width: 80,
              filterable: true,
          }

        ];
        // this.props.products = this.props.products.bind(this);

        return (
          <div>
            <Row>
              <Col sm={ 12 }>
                <div style={{ maxWidth: '99%' }} id="PurchaseQuoteForm-dataGrid1">
                  <ReactDataGrid
                      rowKey='Product_id'
                      enableCellSelect={true}
                      onGridSort={handleGridSort}
                      toolbar={<Toolbar enableFilter={true}/>}
                      onAddFilter={handleFilterChange}
                      columns={columns}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      enableRowSelect='multi'
                      onRowUpdated={handleRowUpdated}
                      rowSelection={{
                        showCheckbox: true,
                        enableShiftSelect: true,
                        onRowsSelected: onRowsSelected,
                        onRowsDeselected: onRowsDeselected,
                        selectBy: {
                         isSelectedKey: 'isSelected'
                        }
                     }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        )
    }
  }

    getAllProductNumOptions() {
      var productNumOptions = [{value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit"}];
      this.props.simplifiedProducts.map(product => {
          let text = "                                                                  ";
          let output = [product.ProductNum.slice(0, 8), text].join('');
          output = [output.slice(0,8), '  |  ', product.Name.slice(0,12), text].join('');
          if(product.Description)
            output = [output.slice(0,26), '  |  ', product.Description.slice(0,50), text].join('');
          else
            output = [output.slice(0,26), '  |  ', '                                                  ', text].join('');
          if(product.MeasureUnit)
            output = [output.slice(0,83), '  |  ', product.MeasureUnit.slice(0,10), text].join('');
          else
            output = [output.slice(0,83), '  |  ', '          ', text].join('');
          output = output.slice(0,99);
          productNumOptions.push({ value: product.Product_id, label: output})
      });
      return productNumOptions;
    }

    getProductNumOptions() {
      var productNumOptions = [{value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit"}];
      this.props.products.map(product => {
          let text = "                                                                  ";
          let output = [product.ProductNum.slice(0, 8), text].join('');
          output = [output.slice(0,8), '  |  ', product.Name.slice(0,12), text].join('');
          if(product.Description)
            output = [output.slice(0,26), '  |  ', product.Description.slice(0,50), text].join('');
          else
            output = [output.slice(0,26), '  |  ', '                                                  ', text].join('');
          if(product.MeasureUnit)
            output = [output.slice(0,83), '  |  ', product.MeasureUnit.slice(0,10), text].join('');
          else
            output = [output.slice(0,83), '  |  ', '          ', text].join('');
          output = output.slice(0,99);
          productNumOptions.push({ value: product.Product_id, label: output})
      });
      return productNumOptions;
    }

    getProductNameOptions() {
        var productNameOptions = [];
        this.props.products.map(product => {
            productNameOptions.push({ value: product.Product_id, label: product.Name })
        });
        return productNameOptions;
    }

    renderCarryTypeShippingMethod() {
        let carryTypeOptions = [
            { value: "Dry", label: "Dry" },
            { value: "Refrigerated", label: "Refrigerated" }
        ];
        let shippingMethodOptions = [
            { value: "Truckxi", label: "Truckxi" },
            { value: "Own Logistic", label: "Own Logistic" }
        ];
        return (
            <Row>
                <Col sm={ 6 }>
                  <label className="col-sm-5 inlineLabel"><Translate value="carry_type" /></label>
                    <Col sm={ 6 }>
                        <Field name="CarryType" component={Selection} options={carryTypeOptions} defaultValue={{value: "Dry", label: "Dry"}}/>
                    </Col>
                </Col>
                <Col sm={ 6 }>
                  <label className="col-sm-5 inlineLabel"><Translate value="shipping_method" /></label>
                    <Col sm={ 6 }>
                        <Field name="ShippingMethod" component={Selection} options={shippingMethodOptions} defaultValue={{value: "Own Logistic", label: "Own Logistic"}}/>
                    </Col>
                </Col>
            </Row>
        )
    }

    // Render the Paymentterms select.

    renderPaymentTerms() {
        if (this.props.paymentTermsIsLoading) return <Spinner/> // If group is loading, show a spinner.
        else {
            let paymentTermOptions = this.getPaymentTermOptions();
            return (
                <Row>
                    <Col sm={ 6 }>
                        <label className="col-sm-5 inlineLabel" ><Translate value="payment_term" /></label>
                          <Col sm={ 6 }>
                            <Field name="PaymentTerm_id" component={Selection} options={paymentTermOptions}/>
                          </Col>
                    </Col>
                </Row>
            )
        }
    }

    getPaymentTermOptions() {
        var paymentTermOptions = [];
        this.props.paymentTerms.map(paymentTerm => {
            paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
        });
        return paymentTermOptions;
    }

    // Dropdown list for payment status
    renderPaymentStatus() {
         let paymentStatusOptions = [
            { value: 'Not Paid', label: 'Not Paid' },
             { value: 'Partially Paid', label: 'Partially Paid' },
             { value: 'Paid', label: 'Paid' },
         ]

         return (
                 <Col sm={ 6 }>
                   <label className="col-sm-6 inlineLabel" ><Translate value="payment_status" /> <span style={{color: 'red'}} >*</span> </label>
                   <Col sm={ 6 }>
                     <Field name="PaymentStatus" component={Selection} options={paymentStatusOptions}/>
                    </Col>
                 </Col>
           )
    }

    renderWarehouse() {
        if (this.props.warehouseIsLoading) return <Spinner/> // If group is loading, show a spinner.
        else {
            let warehouseOptions = this.getWarehouseOptions();
            return (
                <Row>
                    <Col sm={ 6 }>
                      <label className="col-sm-5 inlineLabel" ><Translate value="deliver_warehouse" /> <span style={{color: 'red'}} >*</span> </label>
                        <Col sm={ 6 }>
                            <Field name="Deliver_Warehouse_id" component={Selection} options={warehouseOptions}/>
                        </Col>
                    </Col>
                </Row>
            )
        }
    }

    getWarehouseOptions() {
        var warehouseOptions = [];
        this.props.warehouses.map(warehouse => {
            warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
        });
        return warehouseOptions;
    }

    // Implement the Headers which enable the function of collapsible

    productHeader() {
      return (
        <div>
            <label style={{ cursor: "pointer" }} ><Translate value="product_information" /></label>
        </div>
      )
    }

    pickupHeader() {
      return (
        <div>
            <label style={{ cursor: "pointer" }} ><Translate value="pickup" /></label>
        </div>
      )
    }

    deliverHeader() {
      return (
        <Row>
            <label style={{ cursor: "pointer" }} ><Translate value="deliver_warehouse" /></label>
        </Row>
      )
    }

    carryHeader() {
      return (
        <div>
            <label style={{ cursor: "pointer" }} ><Translate value="carry_type_shipping_method" /></label>
        </div>
      )
    }

    accountHeader() {
      return (
        <div>
            <label style={{ cursor: "pointer" }} ><Translate value="account_payment_term" /></label>
        </div>
      )
    }

    attachmentHeader() {
      return (
        <div>
            <label style={{ cursor: "pointer" }} ><Translate value="attachment_upload" /></label>
        </div>
      )
    }

    vendorHeader() {
        return (
            <div onClick={ () => this.setState({ vendorInformationOpen: !this.state.vendorInformationOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="vendor_information" /></label>
            </div>
        )
    }

    oneTimeScheduleHeader() {
        return (
            <div onClick={ () => this.setState({ oneTimeScheduleOpen: !this.state.oneTimeScheduleOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="one_time_schedule" /></label>
            </div>
        )
    }

    purchaseInformationHeader() {
        return (
            <div onClick={ () => this.setState({ purchaseInformationOpen: !this.state.purchaseInformationOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="purchase_information" /></label>
            </div>
        )
    }

    orderHistoryHeader() {
        return (
            <div onClick={ () => this.setState({ orderHistoryOpen: !this.state.orderHistoryOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="order_history" /></label>
            </div>
        )
    }

    inventoryHeader() {
        return (
            <div onClick={ () => this.setState({ inventoryOpen: !this.state.inventoryOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="inventory" /></label>
            </div>
        )
    }

    onDrop(files) {
        this.setState({
            files: files
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }

    renderPreview() {
        return (
            <div>
                <h4><Translate value="preview" /></h4>
                <hr/>
                <Row><Col sm={ 12 }>
                    <Image src={this.state.files[0].preview} thumbnail/>
                </Col></Row>
            </div>
        )
    }

    placeNewOrder(e) {
        e.preventDefault();
        this.setState({ dirty: false });
        this.props.purchaseQuotePlace(this.props.formProps, Data.Selectors.getRows(this.state), this.props.currentPurchaseQuote.PurchaseOrder_id);
    }

    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    handleFormSubmit(formProps) {
        this.setState({ dirty: false });

        if (this.props.currentPurchaseQuote) {
          if(!this.checkPermission("edit_purchase_quote"))
            this.props.editPurchaseQuote(formProps, Data.Selectors.getRows(this.state));
          else
            alert("You have no permission!");
        }
        else this.props.createPurchaseQuote(formProps, Data.Selectors.getRows(this.state));
    }

    handleMiscCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.miscCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({miscCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleHandlingCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.handlingCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({handlingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleShippingCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.shippingCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({shippingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleDiscountChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(event.target.value || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      // let finalPrice = (totalPrice / (1 - parseFloat(discountValue || 0) / 100.00) * (1 - parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
      this.setState({discountValue: event.target.value, finalPrice: finalPrice});
    }

    handleTaxChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      let discountValue = parseFloat(this.state.discountValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(event.target.value || 0) / 100.0)).toFixed(2);
      // let finalPrice = (totalPrice / (1 + parseFloat(taxValue || 0) / 100.00) * (1 + parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
      this.setState({taxValue: event.target.value, finalPrice: finalPrice});
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        let vendorProducts = (<Translate value="vendor_products" />);
        let allProducts = (<Translate value="all_products" />);
        let convertItemPriceTranslation = (<Translate value="convert_item_price" />);
        let productNumOptions = this.getProductNumOptions();
        let allProductNumOptions = this.getAllProductNumOptions();
        const { handleSubmit, submitting, pristine, isCreating, isEditing } = this.props;
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
        else {
            let productInfo = this.state.productInfo;
            return (
              <ContentWrapper>
                  {this.title() }
                  <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                      <Row>
                          <Col sm={ 4 }>
                              <Panel className="panelStyle" header={this.vendorHeader() } collapsible expanded={this.state.vendorInformationOpen}>
                                  <fieldset>
                                      {this.renderVendorsDetail() }
                                      <Row className="marginBottomStyle" >
                                        <label className="col-sm-3" ><Translate value="billing_address" /></label>
                                          {!this.props.currentVendorDetail && <label className="col-sm-9" ><Translate value="msg_please_select_a_vendor" /> </label>}
                                          {this.props.currentVendorDetail && <label className="col-sm-9" >{this.renderBillingAddress()}</label> }
                                      </Row>
                                      <Row className="marginBottomStyle" >
                                        <Col sm={ 6 }>
                                            <label className="col-sm-6 inlineLabel" ><Translate value="outstanding_order" /></label>
                                            <Col sm={ 6 }><Field name="Outsanding" component={ InputField } /></Col>
                                        </Col>
                                        <Col sm={ 6 }>
                                            <label className="col-sm-6 inlineLabel" ><Translate value="outstanding_invoice" /></label>
                                            <Col sm={ 6 }><Field name="OutstandingInvoice" component={ InputField } /></Col>
                                        </Col>
                                      </Row>
                                      <Row><Col>
                                          <Col sm={ 3 }><label><Translate value="current_order_amount" /></label></Col>
                                          <Col sm={ 9 }><Field name="CurrentOrderAmount" component={ InputField } /></Col>
                                      </Col></Row>
                                  </fieldset>
                                  <fieldset>
                                      { !this.props.vendorContactValue && <label className="col-sm-9" ><Translate value="please_select_a_contact" /></label> }
                                      { this.props.vendorContactValue && this.renderVendorContactInformation() }
                                  </fieldset>
                              </Panel>
                              <Panel className="panelStyle" header={this.oneTimeScheduleHeader() } collapsible expanded={this.state.oneTimeScheduleOpen}>
                                  <Row className="marginBottomStyle" >
                                    <Col sm={ 4 }>
                                      <label><Translate value="order_date" /> <span style={{color: 'red'}} >*</span> </label>
                                      <Field name="OrderDate" component={DatePicker} />
                                    </Col>
                                    <Col sm={ 4 }>
                                      <label><Translate value="eta_date" /></label>
                                      <Field name="ETADate" component={DatePicker} />
                                    </Col>
                                    <Col sm={ 4 }>
                                      <label><Translate value="receive_date" /></label>
                                      <Field name="ReceiveDate" component={DisabledDatePicker} />
                                    </Col>
                                  </Row>
                              </Panel>
                              <Panel className="panelStyle" header={this.purchaseInformationHeader() } collapsible expanded={this.state.purchaseInformationOpen}>
                                  <fieldset>
                                    <Row className="marginBottomStyle">
                                      <Col>
                                        <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="po_num" /></label></Col>
                                        <Col sm={ 9 }>
                                            <Field name="PONum" component={ DisabledInputField }/>
                                        </Col>
                                      </Col>
                                    </Row>
                                    <Row className="marginBottomStyle">
                                      <Col sm={ 6 }>
                                        <label className="col-sm-6 inlineLabel" ><Translate value="purchase_status" /></label>
                                        <Col sm={ 6 }>
                                          <Field name="PurchaseStatus" component={ DisabledInputField }/>
                                        </Col>
                                      </Col>
                                      { this.renderPaymentStatus() }
                                    </Row>
                                  </fieldset>
                                  <fieldset>
                                    <Row className="marginBottomStyle">
                                      <Col sm={6}>
                                          <label className="col-sm-6 inlineLabel" ><Translate value="purchased_by" /></label>
                                          <Col sm={ 6 }>
                                              <Field name="Purchaser_User_id" component={ DisabledInputField }/>
                                          </Col>
                                      </Col>
                                      <Col sm={6}>
                                          <label className="col-sm-6 inlineLabel" ><Translate value="last_modified_by" /></label>
                                          <Col sm={ 6 }>
                                              <Field name="Modifier_User_id" component={ DisabledInputField }/>
                                          </Col>
                                      </Col>
                                    </Row>
                                    <Row className="marginBottomStyle" >
                                      <Col>
                                        <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="note" /></label></Col>
                                        <Col sm={ 9 }>
                                            <Field name="NoteToVendor" component="Textarea" className="form-control" style={{ minHeight: '50px' }}/>
                                        </Col>
                                      </Col>
                                      </Row>
                                  </fieldset>
                                  <fieldset>
                                    <Row className="marginBottomStyle">
                                      <Col sm={6}>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="total_net_weight" /></label>
                                          <Field name="FinalNetWeight" component={ HiddenInputField } V={ this.state.totalNetWeight }/>
                                          <label className="col-sm-6 inlineLabel" style={{paddingLeft: '8px'}}>{this.state.totalNetWeight} lb</label>
                                      </Col>
                                      <Col sm={6}>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="total_shipping_weight" /></label>
                                          <Field name="FinalShippingWeight" component={ HiddenInputField } V={ this.state.totalShippingWeight }/>
                                          <label className="col-sm-6 inlineLabel" style={{paddingLeft: '8px'}} >{this.state.totalShippingWeight} lb</label>
                                        </Col>
                                      </Row>
                                  </fieldset>
                                  <fieldset>
                                    <Row className="marginBottomStyle">
                                      <Col sm={ 6 }>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="shipping_cost" /></label>
                                          <Col sm={ 6 }>
                                            <Field name="ShippingCost" component={ ControlledInputField } placeholder={this.state.shippingCostValue} onChange={this.handleShippingCostChange}/>
                                          </Col>
                                      </Col>
                                      <Col sm={ 6 }>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="handling_cost" /></label>
                                          <Col sm={ 6 }>
                                            <Field name="HandlingCost" component={ ControlledInputField } placeholder={this.state.handlingCostValue} onChange={this.handleHandlingCostChange}/>
                                          </Col>
                                      </Col>
                                      </Row>
                                      <Row className="marginBottomStyle">
                                        <Col sm={ 6 }>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="misc_cost" /></label>
                                          <Col sm={ 6 }>
                                            <Field name="MiscCost" component={ ControlledInputField } placeholder={this.state.miscCostValue} onChange={this.handleMiscCostChange}/>
                                          </Col>
                                        </Col>
                                      </Row>
                                      <Row className="marginBottomStyle" >
                                        <Col>
                                          <Col sm={ 3 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="misc_cost_detail" /></label></Col>
                                            <Col sm={ 9 } style={{float: "left"}}>
                                              <Field name="MiscNote" component={ InputField }/>
                                          </Col>
                                        </Col>
                                      </Row>
                                  </fieldset>
                                  <fieldset>
                                    <Row className="marginBottomStyle">
                                          <label className="col-sm-3 marginTopStyle" ><Translate value="total_price" /></label>
                                          <Field name="TotalPrice" component={ HiddenInputField } V={ this.state.totalPrice } />
                                          <label className="col-sm-9" >$ {this.state.totalPrice}</label>
                                      </Row>
                                      <Row className="marginBottomStyle">
                                        <Col sm={ 6 }>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="discount" /></label>
                                          <Col sm={ 6 }>
                                            <Field name="Discount" component={ ControlledInputField } placeholder={this.state.discountValue} onChange={this.handleDiscountChange}/>
                                          </Col>
                                        </Col>
                                        <Col sm={ 6 }>
                                          <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="tax" /></label>
                                          <Col sm={ 6 }>
                                            <Field name="TaxRate" component={ ControlledInputField } placeholder={this.state.taxValue} onChange={this.handleTaxChange}/>
                                          </Col>
                                        </Col>
                                      </Row>
                                      <Row className="marginBottomStyle">
                                          <label className="col-sm-3 marginTopStyle" ><Translate value="final_dollarsign" /></label>
                                          <Col sm={ 7 }>
                                            <Field name="FinalPrice" component={ HiddenInputField } V={ this.state.finalPrice } />
                                          </Col>
                                          <label className="col-sm-9" >$ {this.state.finalPrice}</label>
                                      </Row>
                                  </fieldset>
                                  <fieldset>
                                      <Field name="ConvertItemPrice" component={ ConvertItemPrice } labelName={convertItemPriceTranslation}/>
                                  </fieldset>
                              </Panel>
                              <Panel className="panelStyle" header={this.orderHistoryHeader() } collapsible expanded={this.state.orderHistoryOpen}>
                                <fieldset>
                                    <Row className="marginBottomStyle">
                                        <Col sm={ 3 }>
                                          <label className="col-sm-12 inlineLabel" ><Translate value="po_num" /></label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo?productInfo.PONum:null}
                                        </Col>
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 inlineLabel" ><Translate value="quantity_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo?productInfo.Quantity:null}
                                        </Col>
                                    </Row>
                                    <Row className="marginBottomStyle">
                                      <Col sm={ 3 }>
                                          <label className="col-sm-12 inlineLabel" ><Translate value="unit_price_colonsign" /> </label>
                                      </Col>
                                      <Col sm={ 3 }>
                                          {productInfo?productInfo.UnitPrice:null}
                                      </Col>
                                      <Col sm={ 3 }>
                                          <label className="col-sm-12 inlineLabel" ><Translate value="purchase_date_colonsign" /> </label>
                                      </Col>
                                      <Col sm={ 3 }>
                                          {(productInfo && productInfo.OrderDate)?productInfo.OrderDate.slice(0, 10):null}
                                      </Col>
                                    </Row>
                                </fieldset>
                              </Panel>
                              <Panel className="panelStyle" header={this.inventoryHeader() } collapsible expanded={this.state.inventoryOpen}>
                                <fieldset>
                                  <Row className="marginBottomStyle" >
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="quantity_colonsign" /></label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.Quantity:null}
                                        </Col>
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="in_stock_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.InStock:null}
                                        </Col>
                                    </Row>
                                    <Row className="marginBottomStyle" >
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="presale_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.PreSale:null}
                                        </Col>
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="purchased_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.Purchased:null}
                                        </Col>
                                    </Row>
                                    <Row className="marginBottomStyle" >
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="min_limit_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.ProductNum.MinStockRange:null}
                                        </Col>
                                        <Col sm={ 3 }>
                                            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="max_limit_colonsign" /> </label>
                                        </Col>
                                        <Col sm={ 3 }>
                                            {productInfo ? productInfo.ProductNum.MaxStockRange:null}
                                        </Col>
                                    </Row>
                                    <Row className="marginBottomStyle" >
                                      <Col>
                                        <Col sm={ 3 }><label className="col-sm-12 inlineLabel" ><Translate value="default_location_colonsign" /> </label></Col>
                                        <Col sm={ 9 }>
                                          {productInfo && productInfo.Warehouse_id && productInfo.Warehouse_id.Name}
                                        </Col>
                                      </Col>
                                    </Row>
                                </fieldset>
                              </Panel>
                          </Col>
                          <Col sm={ 8 }>
                              <Row><Col sm={ 12 }>
                                  <Link to="/purchaseQuote" className="btn btn-default"><em className="fa fa-close"/></Link>
                                  <Button className="btn btn-default" disabled={ submitting || pristine }><em className="fa fa-trash"/></Button>
                                  { (isCreating || isEditing) && <Spinner/> }
                                  { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError) }</div> }
                                  { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError) }</div> }
                                  {this.placeButtons()}
                              </Col></Row>
                              <hr/>
                              <Row>
                                  <Panel>
                                      <Col>
                                          <Row>
                                            <Row>
                                              <Col sm={ 12 }>
                                                <Row>
                                                  <Col sm={ 12 }>
                                                    {this.productHeader()}
                                                    <Tabs defaultActiveKey={ 1 } justified >
                                                      <Tab eventKey={ 1 } title={vendorProducts}>
                                                        <Row>
                                                          <Col sm={ 12 }>
                                                            <Row>
                                                              <Col sm ={ 12 }>
                                                                <Col sm = { 2 }>
                                                                  <label><Translate value="product_num" /></label>
                                                                </Col>
                                                                <Col sm = { 10 }>
                                                                  <Field name="ProductInformation" component={DetailedSelection} options={productNumOptions} onChange={this.setDefault()}/>
                                                                </Col>
                                                              </Col>
                                                            </Row>
                                                            <Row>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="quantity" /></label></Col>
                                                                <Col sm={ 6 }>
                                                                  <Field name="Quantity" component={ ControlledInputField } placeholder={this.state.quantity} onChange={this.handleQuantityChange}/>
                                                                </Col>
                                                              </Col>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="unit_price" /></label></Col>
                                                                  <Col sm={ 6 }>
                                                                    <Field name="FOBUnitPrice" component={ ControlledInputField } placeholder={ this.state.refPrice || this.state.defaultRefPrice } onChange={this.handleUnitPriceChange}/>
                                                                  </Col>
                                                                </Col>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="lowest_sale_dollarsign" /></label></Col>
                                                                  <Col sm={ 6 }>
                                                                    <Field name="EstSalePrice" component={ ControlledInputField } placeholder={ this.state.lowestSalePrice || this.state.defaultLowestSalePrice } onChange={this.handleLowestSalePriceChange}/>
                                                                  </Col>
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                        </Row>
                                                        <br/>
                                                        <Row>
                                                          <Col>
                                                            <Button className="btn btn-primary pull-right" onClick={() => this.moveToProductsList() }>
                                                              <Translate value="move_to_product_list" />
                                                            </Button>
                                                          </Col>
                                                          <Col>
                                                            <Button className="btn btn-primary pull-right" onClick={() => this.moveOffFromProductsList() }>
                                                              <Translate value="move_off_from_products_list" />
                                                            </Button>
                                                          </Col>
                                                        </Row>
                                                      </Tab>
                                                      <Tab eventKey={ 2 } title={allProducts}>
                                                        <Row>
                                                          <Col sm={ 12 }>
                                                            <Row>
                                                              <Col sm ={ 12 }>
                                                                <Col sm = { 2 }><label><Translate value="product_num" /></label></Col>
                                                                <Col sm = { 10 }>
                                                                  <Field name="AllProducts" component={VirtualizedDetailedSelection} options={allProductNumOptions} />
                                                                </Col>
                                                              </Col>
                                                            </Row>
                                                            <Row>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="quantity" /></label></Col>
                                                                <Col sm={ 6 }>
                                                                  <Field name="AllProd_Quantity" component={ InputField } placeholder={0}/>
                                                                </Col>
                                                              </Col>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="unit_price" /></label></Col>
                                                                <Col sm={ 6 }>
                                                                  <Field name="AllProd_FOBUnitPrice" component={ InputField } placeholder={0}/>
                                                                </Col>
                                                              </Col>
                                                              <Col sm={ 4 }>
                                                                <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="lowest_sale_dollarsign" /></label></Col>
                                                                <Col sm={ 6 }>
                                                                  <Field name="AllProd_EstSalePrice" component={ InputField } placeholder={0}/>
                                                                </Col>
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                        </Row>
                                                        <br/>
                                                        <Row>
                                                          <Col>
                                                            <Button className="btn btn-primary pull-right" onClick={() => this.moveToProductsListFromAll() }>
                                                              <Translate value="move_to_product_list" />
                                                            </Button>
                                                          </Col>
                                                          <Col>
                                                            <Button className="btn btn-primary pull-right" onClick={() => this.moveOffFromProductsList() }>
                                                              <Translate value="move_off_from_products_list" />
                                                            </Button>
                                                          </Col>
                                                        </Row>
                                                      </Tab>
                                                    </Tabs>
                                                    <Row>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              </Col>
                                            </Row>
                                            {this.renderProducts()}
                                          </Row>
                                          <Row>
                                            <Panel header={this.pickupHeader()} className="panelStyle">
                                                  {this.renderVendorAddress() }
                                              </Panel>
                                              <Panel header={this.deliverHeader()} className="panelStyle">
                                                  {this.renderWarehouse() }
                                              </Panel>
                                              <Panel header={this.carryHeader()} className="panelStyle">
                                                  {this.renderCarryTypeShippingMethod() }
                                              </Panel>
                                          </Row>
                                          <Row>
                                            <Panel header={this.accountHeader()} className="panelStyle">
                                                  { this.renderPaymentTerms() }
                                                  <br/>
                                                  <Col sm={ 6 }>
                                                  <label className="col-sm-5 inlineLabel"><Translate value="invoice" /></label>
                                                    <Col sm={ 6 }>
                                                      <FieldArray name="Invoices" component={ renderInvoice } />
                                                    </Col>
                                                  </Col>
                                              </Panel>
                                          </Row>
                                          <Row>
                                            <Panel header={this.attachmentHeader()} className="panelStyle">
                                                  <Dropzone onDrop={this.onDrop.bind(this) } className="well dropzone" >
                                                      <Button className="pull-right btn btn-default btn-primary"  onClick={this.onOpenClick} ><Translate value="upload_file" /></Button>
                                                      <div className="dz-default dz-message"><Translate value="msg_drag_drop_attachment"  /></div>
                                                  </Dropzone>
                                                  {this.state.files && this.renderPreview() }
                                              </Panel>
                                          </Row>
                                      </Col>
                                  </Panel>
                              </Row>
                          </Col>
                      </Row>
                      <Row>
                      </Row>
                  </form>
              </ContentWrapper >
            )
        }
    }
}

export default withRouter(PurchaseQuoteForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseQuoteForm.jsx